import "@/App.css";
import LandingPage from "@/pages/LandingPage";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App" data-testid="app-root">
      <LandingPage />
      <Toaster
        position="bottom-center"
        theme="dark"
        toastOptions={{
          style: {
            background: "rgba(10, 20, 40, 0.92)",
            border: "1px solid rgba(212, 175, 55, 0.35)",
            color: "#FDFBF7",
            backdropFilter: "blur(16px)",
          },
        }}
      />
    </div>
  );
}

export default App;
